<template>
    <div>
        <v-card>
            <v-toolbar card color="white">
                <v-text-field
                    flat
                    solo
                    hide-details
                    prepend-icon="search"
                    placeholder="Tìm trên danh sách khách hàng"
                    v-model="table.searchText"
                    v-on:keyup.enter="search()"
                ></v-text-field>
                <v-tooltip bottom>
                    <v-btn icon slot="activator" @click="exportToExcel()">
                        <v-icon>save_alt</v-icon>
                    </v-btn>
                    <span>Tải về danh sách khách hàng</span>
                </v-tooltip>
                <v-menu offset-y origin="center center" :nudge-bottom="10" v-if="isFilter">
                    <v-btn icon slot="activator">
                        <v-icon>filter_list</v-icon>
                    </v-btn>
                    <v-card>
                        <v-card-title>Bộ lọc</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-radio-group v-model="filter" column>
                                <v-radio label="Tất cả" value="All"></v-radio>
                                <v-radio label="Nhà phân phối" value="DISTRIBUTOR"></v-radio>
                                <v-radio label="Đại lý" value="Dealer"></v-radio>
                                <v-radio label="Khách hàng" value="Customer"></v-radio>
                            </v-radio-group>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
                <v-data-table
                    item-key="id"
                    :headers="table.headers"
                    :items="datasourceFiltered"
                    :rows-per-page-items="[10,20,50,100]"
                    :loading="isLoading"
                    :pagination.sync="paginationSync"
                    @update:pagination="changePage"
                    :total-items="totalItems"
                >
                    <template slot="items" slot-scope="props">
                       <td>
                            <v-tooltip bottom>
                                <v-btn icon slot="activator" @click="openDialogDtCode(props.item)">
                                    <v-icon color="orange">edit</v-icon>
                                </v-btn>
                                <span>Cập nhật mã DT Code</span>
                            </v-tooltip>
                        </td>
                        <td>{{ props.item.dtCode || '--' }}</td>
                        <td>{{ props.item.dealerName }}</td>
                        <td>
                            <v-btn
                                flat
                                round
                                small
                                color="primary"
                                :to="getAccountDetailLink(props.item)"
                                class="link-button"
                            >
                                {{ getAccountName(props.item) }}
                                <span
                                    v-show="false"
                                >{{props.item.name}}</span>
                            </v-btn>
                        </td>
                        <td>{{ props.item.phone }}</td>
                        <td>{{ props.item.email }}</td>
                        <td style="width:200px;
                                   white-space:nowrap;
                                   overflow:hidden;
                                   text-overflow:ellipsis;
                                   ">
                                   {{ props.item.address }}
                        </td>
                        <td>{{ props.item.vehicle }}</td>
                        <td>{{ props.item.device }}</td>
                        <td>{{ props.item.sim }}</td>
                        <td class="no-wrap">{{ new Date(props.item.createdDate).toISOString().slice(0,10) }}</td>
                        <td>
                            <v-tooltip bottom>
                              <v-btn icon slot="activator" @click="openDialogManager(props.item)">
                                <v-icon>manage_accounts</v-icon>
                              </v-btn>
                              <span>Thay đổi người quản lí</span>
                            </v-tooltip>
                        </td>
                       
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <v-dialog v-model="showDtCodeDialog" max-width="400">
          <v-card>
            <v-card-title class="headline">Nhập DT Code</v-card-title>
            <v-card-text>
              <v-text-field
                label="DT Code"
                v-model="dtCodeInput"
                :rules="dtCodeRules"
                counter="10"
                maxlength="10"
                required
                autofocus
              ></v-text-field>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="showDtCodeDialog = false">Hủy</v-btn>
              <v-btn 
                color="primary" 
                flat 
                @click="saveDtCode"
                :disabled="!isDtCodeValid"
              >Lưu</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <!-- Dialog thay đổi user manager -->
      <dialog-manager ref="dialogChangeManager" @changeSuccess="handleChangeManager"/>
      <!-- Dialog thay đổi user manager -->
    </div>
</template>

<script>
import XLSX from 'xlsx';
import validate from '@/utils/validate';
import DialogManager from '../../../components/dialog/DialogManager.vue';
export default {
  components: {
    DialogManager
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: () => []
    },
    totalItems: {
      type: Number,
      default: 0
    },
    isFilter: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      table: {
        searchText: '',
        headers: [
          {
            text: '',
            value: '#'
          },
          {
            text: 'DT',
            value: 'dtCode'
          },
          {
            text: 'Nhà phân phối / Đại lý',
            value: 'dealerName'
          },
          {
            text: 'Khách hàng',
            value: 'name'
          },
          {
            text: 'SĐT',
            value: 'phone'
          },
          {
            text: 'Email',
            value: 'email'
          },
          {
            text: 'Địa chỉ',
            value: 'address'
          },
          {
            text: 'Số xe',
            value: 'vehicle'
          },
          {
            text: 'Số thiết bị',
            value: 'device'
          },
          {
            text: 'Số lượng sim',
            value: 'sim'
          },
          {
            text: 'Ngày tạo',
            value: 'createdDate'
          },
          {
            text: '',
            value: '#'
          }
        ]
      },
      filter: 'All',
      datasourceFiltered: [],
      paginationSync: { // Pagination cho table
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
      params: {
        keySearch: '',
        pageIndex: 1,
        pageSize: 10,
        filter: 'All'
      },
      showDtCodeDialog: false,
      dtCodeInput: '',
      selectedAccount: null,
      dtCodeRules: [
        v => !!v || 'DT Code không được để trống',
        v => (v && v.length <= 10) || 'Tối đa 10 ký tự'
      ],
    };
  },
  computed: {
    isDtCodeValid () {
      return (
        this.dtCodeInput &&
        this.dtCodeInput.length > 0 &&
        this.dtCodeInput.length <= 10
      );
    }
  },

  watch: {
    filter () {
      this.params.filter = this.filter;
      this.params.pageIndex = 1;

      // Set page = 1 cho table khi được filter
      this.paginationSync.page = 1;

      this.$emit('changePage', this.params);
    },
    datasource () {
      this.datasourceFiltered = this.datasource;
    }
  },

  methods: {
    getAccountParentName: account => {
      return account.dealerName;
    },
    getAccountDetailLink: account => `/account/detail?accountId=${account.id}`,
    getAccountLinkColor: account => {
      return account.isDistributor
        ? 'red'
        : account.isDealer
          ? 'green'
          : 'primary';
    },
    getAccountName: account => {
      return (
        (account.isDistributor ? 'NPP - ' : account.isDealer ? 'ĐL - ' : '') +
        account.name
      );
    },
    exportToExcel () {
      this.$emit('exportFile');
    },
    search () {
      let searchText = this.table.searchText.trim();
      this.params.keySearch = searchText;
      this.params.pageIndex = 1;

      // Set page = 1 cho table khi được filter
      this.paginationSync.page = 1;

      this.$emit('changePage', this.params);
    },

    changePage (pagination) {
      this.params.pageIndex = pagination.page;
      this.params.pageSize = pagination.rowsPerPage;
      this.$emit('changePage', this.params);
    },
    openDialogManager (item) {
      this.$refs.dialogChangeManager.open(item);
    },
    handleChangeManager () {
      this.$emit('changePage', this.params);
    },

    openDialogDtCode (item) {
      this.selectedAccount = item;
      this.dtCodeInput = item.dtCode || '';
      this.showDtCodeDialog = true;
    },

    saveDtCode () {
      this.showDtCodeDialog = false;
      this.$emit('updateDtCode', {
        id: this.selectedAccount.id,
        dtCode: this.dtCodeInput
      });
    },

  }
};
</script>

<style scoped>
.v-card__text {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
.link-button {
    min-width: 0px !important;
    margin-left: -7px !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/account/components/list.vue